// GENERATE BY ./scripts/generate.ts
// DON NOT EDIT IT MANUALLY
import * as React from 'react';
import MessageReadOutlinedSvg from "@fishx/icons-svg/es/asn/MessageReadOutlined";
import FishxIcon from '../components/FishxIcon';

var MessageReadOutlined = function MessageReadOutlined(props, ref) {
  return React.createElement(FishxIcon, Object.assign({}, props, {
    ref: ref,
    icon: MessageReadOutlinedSvg
  }));
};

MessageReadOutlined.displayName = 'MessageReadOutlined';
export default React.forwardRef(MessageReadOutlined);


//////////////////
// WEBPACK FOOTER
// ./node_modules/@fishx/icons/es/icons/MessageReadOutlined.js
// module id = 3132
// module chunks = 0